const INITIAL_STATE = {
  authUser: undefined,
  isAuthenticating: true
};

const applySetAuthUser = (state, action) => ({
  ...state,
  isAuthenticating: action.authUser === INITIAL_STATE.authUser,
  authUser: action.authUser,
});

function sessionReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'AUTH_USER_SET': {
      return applySetAuthUser(state, action);
    }
    case 'AUTH_USER_UPDATE': {
      const authUser = { ...state.authUser, ...action.data };
      return { ...state, authUser };
    }
    default:
      return state;
  }
}

export default sessionReducer;